import { ValidatorFn, AbstractControl } from '@angular/forms';

export class ControlValidators {
	static applyValidatorsToControl(control: AbstractControl, validatorsSet: ValidatorFn[]): void {
		if (validatorsSet.length > 0) {
			control.setValidators(validatorsSet);
			control.updateValueAndValidity();
		}
	}

	static resetValidators(control: AbstractControl): void {
		control.clearValidators();
		control.updateValueAndValidity();
	}
}
